import { useEffect, useState } from 'react';
import type { AltYState } from '../types/global';

const stateEvent = 'idsys.alty.state';

const defaultState: AltYState = {
  isOpen: false,
  reservedWidth: 0,
};

export function useAltYState() {
  const [state, setState] = useState<AltYState>(defaultState);

  useEffect(() => {
    function handleState(event: Event) {
      const detail = (event as CustomEvent<AltYState>).detail;
      setState({
        isOpen: !!detail?.isOpen,
        reservedWidth: Number(detail?.reservedWidth || 0),
      });
    }

    window.addEventListener(stateEvent, handleState);
    window.AltY?.emitState?.();
    return () => window.removeEventListener(stateEvent, handleState);
  }, []);

  return state;
}
